import type { Template } from "@/types";

export const PO_07_H0_V7: Template[] = [
    {
        id: "po-07-h0v7-01",
        name: "PO 01 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 289, width: 164, height: 272, rotation: 0, imageRotation: 0 },
            { id: "2", x: 172, y: 289, width: 163, height: 272, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 289, width: 163, height: 272, rotation: 0, imageRotation: 0 },
            { id: "4", x: 514, y: 289, width: 163, height: 272, rotation: 0, imageRotation: 0 },
            { id: "5", x: 685, y: 289, width: 163, height: 272, rotation: 0, imageRotation: 0 },
            { id: "6", x: 856, y: 289, width: 163, height: 272, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1027, y: 289, width: 163, height: 272, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-02",
        name: "PO 02 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_02.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 61, y: 177, width: 153, height: 245, rotation: 0, imageRotation: 0 },
            { id: "2", x: 222, y: 177, width: 153, height: 245, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 177, width: 152, height: 245, rotation: 0, imageRotation: 0 },
            { id: "4", x: 61, y: 430, width: 153, height: 244, rotation: 0, imageRotation: 0 },
            { id: "5", x: 222, y: 430, width: 153, height: 244, rotation: 0, imageRotation: 0 },
            { id: "6", x: 383, y: 430, width: 152, height: 244, rotation: 0, imageRotation: 0 },
            { id: "7", x: 736, y: 177, width: 313, height: 495, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-03",
        name: "PO 03 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_03.png",
        size: [1190, 850],
        style: {},
        slots: [          
            { id: "1", x: 135, y: 94, width: 159, height: 216, rotation: 0, imageRotation: 0 },
            { id: "2", x: 302, y: 94, width: 159, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 135, y: 318, width: 159, height: 216, rotation: 0, imageRotation: 0 },
            { id: "4", x: 302, y: 318, width: 159, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 135, y: 542, width: 159, height: 215, rotation: 0, imageRotation: 0 },
            { id: "6", x: 302, y: 542, width: 159, height: 215, rotation: 0, imageRotation: 0 },
            { id: "7", x: 691, y: 94, width: 403, height: 662, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-04",
        name: "PO 04 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 36, y: 0, width: 523, height: 850, rotation: 0, imageRotation: 0 },
            { id: "2", x: 638, y: 148, width: 165, height: 273, rotation: 0, imageRotation: 0 },
            { id: "3", x: 811, y: 148, width: 165, height: 273, rotation: 0, imageRotation: 0 },
            { id: "4", x: 984, y: 148, width: 164, height: 273, rotation: 0, imageRotation: 0 },
            { id: "5", x: 638, y: 429, width: 165, height: 273, rotation: 0, imageRotation: 0 },
            { id: "6", x: 811, y: 429, width: 165, height: 273, rotation: 0, imageRotation: 0 },
            { id: "7", x: 984, y: 429, width: 164, height: 273, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-05",
        name: "PO 05 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 47, y: 225, width: 247, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 642, y: 225, width: 247, height: 400, rotation: 0, imageRotation: 0 },
            { id: "3", x: 897, y: 225, width: 247, height: 400, rotation: 0, imageRotation: 0 },
            { id: "4", x: 302, y: 225, width: 119, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 302, y: 429, width: 119, height: 196, rotation: 0, imageRotation: 0 },
            { id: "6", x: 429, y: 225, width: 119, height: 196, rotation: 0, imageRotation: 0 },
            { id: "7", x: 429, y: 429, width: 119, height: 196, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-06",
        name: "PO 06 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 56, y: 162, width: 381, height: 528, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 445, y: 162, width: 107, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 445, y: 341, width: 107, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 445, y: 520, width: 107, height: 170, rotation: 0, imageRotation: 0 },
            { id: "5", x: 639, y: 162, width: 328, height: 528, rotation: 0, imageRotation: 0 },
            { id: "6", x: 975, y: 162, width: 161, height: 260, rotation: 0, imageRotation: 0 },
            { id: "7", x: 975, y: 430, width: 161, height: 260, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-07",
        name: "PO 07 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_07.png",
        size: [1190, 850],
        style: {},
        slots: [          
            { id: "1", x: 59, y: 83, width: 209, height: 339, rotation: 0, imageRotation: 0 },
            { id: "2", x: 59, y: 430, width: 209, height: 339, rotation: 0, imageRotation: 0 },
            { id: "3", x: 276, y: 83, width: 209, height: 339, rotation: 0, imageRotation: 0 },
            { id: "4", x: 276, y: 430, width: 209, height: 339, rotation: 0, imageRotation: 0 },
            { id: "5", x: 493, y: 83, width: 421, height: 685, rotation: 0, imageRotation: 0 },
            { id: "6", x: 923, y: 83, width: 209, height: 339, rotation: 0, imageRotation: 0 },
            { id: "7", x: 923, y: 430, width: 209, height: 339, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-08",
        name: "PO 08 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_08.png",
        size: [1190, 850],
        style: {},
        slots: [           
            { id: "1", x: 69, y: 90, width: 205, height: 332, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 430, width: 205, height: 331, rotation: 0, imageRotation: 0 },
            { id: "3", x: 282, y: 90, width: 204, height: 332, rotation: 0, imageRotation: 0 },
            { id: "4", x: 282, y: 430, width: 204, height: 331, rotation: 0, imageRotation: 0 },
            { id: "5", x: 494, y: 90, width: 204, height: 332, rotation: 0, imageRotation: 0 },
            { id: "6", x: 494, y: 430, width: 204, height: 331, rotation: 0, imageRotation: 0 },
            { id: "7", x: 706, y: 90, width: 414, height: 671, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-09",
        name: "PO 09 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_09.png",
        size: [1190, 850],
        style: {},
        slots: [       
            { id: "1", x: 59, y: 83, width: 210, height: 339, rotation: 0, imageRotation: 0 },
            { id: "2", x: 59, y: 430, width: 210, height: 339, rotation: 0, imageRotation: 0 },
            { id: "3", x: 278, y: 83, width: 421, height: 686, rotation: 0, imageRotation: 0 },
            { id: "4", x: 707, y: 83, width: 209, height: 339, rotation: 0, imageRotation: 0 },
            { id: "5", x: 707, y: 430, width: 209, height: 339, rotation: 0, imageRotation: 0 },
            { id: "6", x: 924, y: 83, width: 208, height: 339, rotation: 0, imageRotation: 0 },
            { id: "7", x: 924, y: 430, width: 208, height: 339, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-10",
        name: "PO 10 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_10.png",
        size: [1190, 850],
        style: {},
        slots: [          
            { id: "1", x: 0, y: 207, width: 141, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 429, width: 141, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 149, y: 207, width: 141, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 149, y: 429, width: 141, height: 214, rotation: 0, imageRotation: 0 },
            { id: "5", x: 298, y: 207, width: 293, height: 436, rotation: 0, imageRotation: 0 },
            { id: "6", x: 599, y: 207, width: 292, height: 436, rotation: 0, imageRotation: 0 },
            { id: "7", x: 899, y: 207, width: 292, height: 436, rotation: 0, imageRotation: 0 },
        ],
    }
];